import React, { Component } from 'react';

import './styles.css';

export default class NotificationPopUp extends Component {

    constructor(props) {
        super(props)
        this.state = {
            purchaseOrderNumber: '',
            suffix: '',
            itemId: '',
            qty: '',
        }
    }

    onClose = e => {
        this.props.onClose(false);
    };

    render() {
        if(!this.props.show) {
            return null;
        }
        return (
            <div className="modal-background">
            <div className="errorDataModal-container">
                <div className="errorDataModal-form">
                    <h2 className="modal-title">Error in data</h2>
                    <table className="table">
                    <tbody>
                       {
                           this.props.data.map((data,key) => {
                               return(
                                <tr  key={key}>
                                    <td className="text-center">{data.text}</td>
                                </tr>
                               )
                           })
                       }
                    </tbody>
                    </table>
                   
                </div>
                <button type="button" className="btn btn-warning button-errorClose btn-sm" onClick={e => {this.onClose(e)}}>Close</button>
            </div>
        </div>
        );

    }
    
}

